<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label"><span class="mr-2">Request Form Info </span></div>
    </div>

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>{{ _.get(request_form, 'ftie_id', '') }} </div>
          </div>
          <div class="header-col">
            <div>Vertical</div>
            <div>{{ _.get(request_form, 'vertical', '') }} </div>
          </div>
          <div class="header-col">
            <div>Price</div>
            <div>{{ _.get(request_form, 'price', '') }} </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Request Form ID</div>
            <div>{{ _.get(request_form, 'uni_id', '') }}</div>
          </div>
          <div class="header-col">
            <div>Create Date</div>
            <div>{{ _.get(request_form, 'create_date', '') | dateTimeFormat }} </div>
          </div>
          <div class="header-col">
            <div>Status</div>
            <div>{{ _.get(request_form, 'status', '') }} </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Project</div>
            <div>{{ _.get(request_form, 'project', '') }}</div>
          </div>
          <div class="header-col">
            <div>Qty</div>
            <div>{{ _.get(request_form, 'qty', '') }}</div>
          </div>
          <div class="header-col">
            <div>Create by</div>
            <div>{{ _.get(request_form, 'create_by', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Proposal Sharepoint Url</div>
            <div>
              <a v-if="_.get(request_form, 'customization_proposal_url', '') !=='' && _.get(request_form, 'customization_proposal_url', '') !=null"
                 class="link" target="_blank"
                 :href="safeUrl(`${ _.get(request_form, 'customization_proposal_url', '')}`)">
                {{ _.get(request_form, 'model', '') }};FTIE ID{{ _.get(request_form, 'ftie_id', '') }};Request Form ID{{ _.get(request_form, 'uni_id', '') }}
              </a>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Complete Date</div>
            <div v-if="_.get(tl_approval, 'last_update_date', '') !=='' && _.get(tl_approval, 'last_update_date', '') !=null">
              {{_.get(tl_approval, 'last_update_date', '') | dateFormat}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion -- Header ---->
    <!--#region -- Body ---->
    <div class="caption-label">RD Check Item <div class="ml-3 mb-1 d-print-none"></div></div>
    <div v-if="rd_check_item_data !=null" class="table-responsive" style="min-height: 2.5rem;">
      <b-table :fields="fields" :items="rd_check_item_data"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">

        <template #cell(special_list)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.special_list" />
        </template>

        <template #cell(schedule_m_d)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.schedule_m_d" />
        </template>

        <template #cell(man_power)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.man_power" />
        </template>

        <template #cell(relation_dept)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.relation_dept" />
        </template>

        <!-- ── rd_check_item_details cell: checkboxes + per-detail cost panel ── -->
        <template #cell(rd_check_item_details)="data">
          <div v-for="(detail, index) in data.item.rd_check_item_details" :key="index" class="mb-2">

            <!-- Checkbox row + Cost toggle button -->
            <div class="d-flex align-items-center flex-wrap">
              <b-form-checkbox v-model="detail.item_check_yn"
                               :disabled="checkBelongOwner(data.item.owner)"
                               value="Y"
                               unchecked-value="N"
                               class="mr-1">
                {{ detail.item_detail }}
              </b-form-checkbox>
              <b-button size="sm"
                        variant="outline-secondary"
                        class="py-0 px-1 d-print-none"
                        style="font-size:0.75rem; line-height:1.4;"
                        @click="toggleCostPanel(detail.item_detail)">
                {{ showCostPanel[detail.item_detail] ? '▲ Cost' : '▼ Cost' }}
              </b-button>
            </div>

            <!-- Cost collapse panel -->
            <b-collapse :visible="!!showCostPanel[detail.item_detail]" class="mt-1 ml-3">
              <div v-if="costsByItem[detail.item_detail]" class="border rounded p-2" style="background:#f8f9fa;">

                <!-- Device Qty -->
                <div class="d-flex align-items-center mb-2">
                  <small class="mr-2 font-weight-bold text-nowrap">Device Qty:</small>
                  <b-form-input type="number"
                                size="sm"
                                style="width:80px;"
                                :min="1"
                                v-model="costsByItem[detail.item_detail].deviceQty"
                                :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                </div>

                <!-- REF PN -->
                <div class="d-flex align-items-center mb-2">
                  <small class="mr-2 font-weight-bold text-nowrap">Ref Part Number:</small>
                  <b-form-input type="number"
                                size="sm"
                                style="width:80px;"
                                :min="1"
                                v-model="costsByItem[detail.item_detail].refPN"
                                :disabled="costsByItem[detail.item_detail].requiredRefPN !== true || detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                </div>

                <!-- Cost table -->
                <table class="table table-sm table-bordered mb-1" style="font-size:0.8rem; min-width:520px;">
                  <thead class="thead-light">
                    <tr>
                      <th>費用項目 (Cost Item)</th>
                      <th style="width:120px;">金額 NTD</th>
                      <th style="width:160px;">備註</th>
                      <th style="width:110px;">參考料號</th>
                      <th class="d-print-none" style="width:38px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Required rows — non-deletable -->
                    <tr v-for="(cost, ci) in costsByItem[detail.item_detail].requiredCosts" :key="'r' + ci"
                        style="background:#fff;" v-if="cost.name !== '參考料號'">
                      <td>
                        <small class="text-dark font-weight-bold">{{ cost.name }}</small>
                      </td>
                      <td>
                        <b-form-input type="number"
                                      size="sm"
                                      placeholder="0"
                                      v-model="cost.value"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td>
                        <b-form-input size="sm"
                                      placeholder="備註"
                                      v-model="cost.note"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td>
                        <b-form-input size="sm"
                                      placeholder="P/N"
                                      v-model="cost.refPartNo"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td></td>
                    </tr>

                    <!-- Extra rows — user-added, deletable -->
                    <tr v-for="(cost, ei) in costsByItem[detail.item_detail].extraCosts" :key="'e' + ei"
                        style="background:#fffbe6;">
                      <td>
                        <b-form-input size="sm"
                                      placeholder="費用名稱"
                                      v-model="cost.name"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td>
                        <b-form-input type="number"
                                      size="sm"
                                      placeholder="0"
                                      v-model="cost.value"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td>
                        <b-form-input size="sm"
                                      placeholder="備註"
                                      v-model="cost.note"
                                      :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)" />
                      </td>
                      <td></td>
                      <td class="d-print-none text-center">
                        <b-button size="sm"
                                  variant="outline-danger"
                                  class="p-0"
                                  style="width:26px; height:26px; line-height:1;"
                                  :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)"
                                  @click="removeExtraCostRow(detail.item_detail, ei)">
                          ✕
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5" class="text-right py-1">
                        <small class="font-weight-bold">
                          Subtotal
                          (×{{ parseInt(costsByItem[detail.item_detail].deviceQty) || 1 }} qty):
                          {{ getSubtotal(detail.item_detail).toLocaleString() }} NTD
                        </small>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <!-- Add extra row button -->
                <b-button size="sm"
                          variant="outline-primary"
                          class="d-print-none"
                          :disabled="detail.item_check_yn !== 'Y' || checkBelongOwner(data.item.owner)"
                          @click="addExtraCostRow(detail.item_detail)">
                  + Add Cost Row
                </b-button>

              </div>
            </b-collapse>
          </div>
        </template>
        <!-- ── end rd_check_item_details ── -->

        <template #cell(action)="data">
          <b-button v-if="data.item.owner===login_user_name" variant="primary" @click="updateCheckItemDetail(data.item)">Update</b-button>
        </template>

        <template #cell(agree)="data">
          <b-form-radio-group v-model="data.item.agree">
            <b-form-radio value="Y">Yes</b-form-radio>
            <b-form-radio value="N">No</b-form-radio>
          </b-form-radio-group>
        </template>

      </b-table>
    </div>

    <!-- ── Cost Overview & Save Cost ─────────────────────────────────────── -->
    <div class="mt-3 mb-2 d-print-none d-flex align-items-center">
      <b-button variant="outline-info"
                size="sm"
                @click="showCostOverview = !showCostOverview">
        {{ showCostOverview ? '▲ Hide Cost Overview' : '▼ Show Cost Overview' }}
      </b-button>
      <b-button variant="success"
                size="sm"
                class="ml-2"
                @click="saveCostData">
        Save Cost Data
      </b-button>
    </div>

    <b-collapse :visible="showCostOverview" class="mb-4">
      <b-card header="Cost Overview (Selected Items Only)" header-class="font-weight-bold bg-light py-2">
        <table class="table table-sm table-bordered mb-0" style="font-size:0.85rem;">
          <thead class="thead-light">
            <tr>
              <th>Check Item</th>
              <th style="width:90px;" class="text-center">Device Qty</th>
              <th style="width:150px;" class="text-right">Subtotal (NTD)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="costSummary.rows.length === 0">
              <td colspan="3" class="text-center text-muted py-3">
                No selected items with cost data yet.<br>
                <small>Check an item and open its ▼ Cost panel to enter values.</small>
              </td>
            </tr>
            <tr v-for="(row, i) in costSummary.rows" :key="i">
              <td><small>{{ row.label }}</small></td>
              <td class="text-center">{{ row.qty }}</td>
              <td class="text-right">{{ row.subtotal.toLocaleString() }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold" style="background:#e9f5e9;">
              <td colspan="2" class="text-right">Grand Total:</td>
              <td class="text-right">{{ costSummary.grandTotal.toLocaleString() }} NTD</td>
            </tr>
          </tfoot>
        </table>
      </b-card>
    </b-collapse>
    <!-- ── end Cost Overview ──────────────────────────────────────────────── -->

    <div class="caption-label d-flex flex-nowrap" v-if="login_user_name==='albert.chen'">
      RD Leader Comment
      <div class="ml-3 mb-1 d-print-none">
        <b-form-select class="min-w-2" :options="tl_comments_option" label="TL Comments:" @change="handleInputChange"></b-form-select>
      </div>
    </div>
    <div class="col-6">
      <gtc-textarea class="mb-2" v-model="fesc_tl_comment" v-if="login_user_name==='albert.chen'" />
      <b-button variant="primary" @click="updateRequestForm(false)" v-if="login_user_name==='albert.chen'">Comment Submit</b-button>
      <b-button variant="primary" @click="updateRequestForm(true)" v-if="login_user_name==='albert.chen' || isProposalLeader">Proposal Complete</b-button>
    </div>

    <!--#region Reference Files-->
    <!--<div class="row" v-if="login_user_name==='albert.chen' || login_user_name==='corin.chiu'">
      <div class="col-6">
        <div class="caption-label d-flex">
          <div>RD Leader Summarize Comment</div>
        </div>
        <div>
          <gtc-textarea :read-only="false" v-model="rd_leader_comment" />
          <b-button variant="primary" @click="updateRdLeaderComment">Save</b-button>
        </div>
      </div>

    </div>-->
    <!--<div class="row" v-if="login_user_name==='albert.chen' || login_user_name==='corin.chiu' ">
    <div class="col-6">
      <div class="caption-label d-flex">
        <div>RD Leader Summarize</div>
        <div class="ml-3 mt-2 d-print-none">
          <label class="btn btn-primary btn-sm">
            <span>Upload</span>
            <input type="file" class="d-none" v-on:change="uploadfile($event)" />
          </label>
        </div>
      </div>

      <div>
        <b-table  small thead-class="thead-light text-dark" style="table-layout: fixed;" :items="ref_proposal_files" :fields="referenceFilesSetting">

          <template #cell(file_name)="data">
            <a class="link" @click="downloadAttachment(data.item.file_name,  data.item.old_file_name )">{{ data.item.old_file_name }}</a>
          </template>
        </b-table>
      </div>-->
    <!--#endregion-->
    <!--#endregion -- Body ---->
    <!--</div>
    </div>-->
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';

  // ─── Cost category mapping ──────────────────────────────────────────────────
  // Key   = item_detail string (exact match with checklist item text).
  // Value = array of required cost field names for that item.
  // To add more items: append a new key-value pair here — no other code change needed.
  const COST_CATEGORIES = {
    '1. 功能改變，影響原有硬體設計 (PCB)': [
      'POC單價差異', '單價差異', 'Lab測試/debug 費', 'PCB Fabrication Fee', '生產治具費', '外包設計費', '參考料號'
    ],
    '2. 功能改變，影響韌體設計': [
      'FW開發費', 'Lab測試/debug 費', '外包設計費'
    ],
    '3. 功能改變，影響軟體設計': [
      'SW開發費', 'Lab測試/debug 費', '外包設計費'
    ],
    '4. 功能改變，影響機構設計': [
      'Tooling費', '外觀樣品費', 'Lab測試/debug 費', '外包設計費'
    ],
    '5. 功能改變，影響包裝設計': [
      '包材Tooling費', '樣品費', '外包設計費'
    ],
    '6. 特殊測試認證': [
      '認證費', 'Lab測試/debug 費', '出差費'
    ],
    '7. 供應商變更': [
      '樣品費', 'Lab測試/debug 費', '資料轉換費'
    ],
    '8. 其他 (Other)': [
      '其他費用'
    ],
    // 11,其他(敘述)
    // try to mapping current item
    '1,需layout設計新板子': [
      'POC單價差異', '單價差異', 'Lab測試/debug 費', 'PCB Fabrication Fee', '生產治具費', '外包設計費', '參考料號'
    ],
    '3,不做新板子，只是對既有預留PCB中加入新功能': [
      'POC單價差異', '單價差異', '參考料號'
    ],
    '8,零件等級改變，需修改BOM': [
      'POC單價差異', '單價差異', '參考料號'
    ],
    '11,其他(敘述)': [
      'POC單價差異', '單價差異', '認證費', 'Lab測試/debug 費', 'PCB Fabrication Fee', '生產治具費', '外包設計費', '出差費', '參考料號'
    ],
    // ↑ Add more checklist items here following the same pattern
  };

  // Build a fresh cost entry object for a given item_detail string.
  function makeCostEntry(itemDetail) {
    const required = (COST_CATEGORIES[itemDetail] || []).map(name => ({
      name,
      value: '',
      note: '',
      refPartNo: '',
    }));
    if (COST_CATEGORIES[itemDetail] !== null && _.indexOf(COST_CATEGORIES[itemDetail], '參考料號') > -1 ) {
      return { requiredCosts: required, extraCosts: [], deviceQty: 1, refPN: null, requiredRefPN: true };
    }
    else {
      return { requiredCosts: required, extraCosts: [], deviceQty: 1, refPN: null, requiredRefPN: false };
    }
    
  }

  // Safe numeric parser: returns 0 for empty / non-numeric strings.
  function safeNum(v) {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }
  // ────────────────────────────────────────────────────────────────────────────

  export default {
    name: 'rd-check-item',
    data() {
      return {
        // ── existing fields (unchanged) ──────────────────────────────────────
        function_name: 'RdCheckItemCost',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        login_user_name: null,
        userSites: null,
        userRoles: null,
        userFunctions: null,
        fields: null,
        referenceFilesSetting: [
          { key: 'file_name', label: 'File Name', thClass: 'align-middle ', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle ', sortable: false }
        ],
        rd_check_item_data: null,
        request_form: null,
        rd_leader_comment: null,
        ref_proposal_files: [],
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        tl_comments_option: [
          'Goto Kickoff directly.',
          'Need Feasibility check meeting with PM',
          'Create PN/BOM directly.',
          'Feasibility check directly.',
          'Other Comments'
        ],
        proposal_complete_date: null,
        fesc_tl_comment: null,
        tl_approval: null,

        // ── NEW: cost feature state ──────────────────────────────────────────
        // costsByItem[item_detail] = { requiredCosts[], extraCosts[], deviceQty }
        costsByItem: {},
        // showCostPanel[item_detail] = boolean (collapse open/closed)
        showCostPanel: {},
        // toggle for the bottom overview panel
        showCostOverview: false,
      };
    },
    created() {
      let self = this;
      self.getRdCheckItem();
    },
    computed: {
      // ── existing computed (unchanged) ─────────────────────────────────────
      isProposalLeader() {
        let self = this;
        if (!self.rd_check_item_data) return false;
        const found = self.rd_check_item_data.find(
          x => x.sub_function_name === 'Proposal Leader' && x.owner === self.login_user_name
        );
        return !!found;
      },

      // ── NEW: cost summary for the overview panel ──────────────────────────
      // Returns { rows: [{ label, subtotal, qty }], grandTotal }
      // Only includes items where item_check_yn === 'Y'.
      costSummary() {
        const self = this;
        const rows = [];
        let grandTotal = 0;

        if (!self.rd_check_item_data) return { rows, grandTotal };

        self.rd_check_item_data.forEach(item => {
          (item.rd_check_item_details || []).forEach(detail => {
            if (detail.item_check_yn !== 'Y') return;
            const entry = self.costsByItem[detail.item_detail];
            if (!entry) return;

            const qty = parseInt(entry.deviceQty) || 1;
            const allCosts = [...entry.requiredCosts, ...entry.extraCosts];
            const subtotal = allCosts.reduce((s, c) => s + safeNum(c.value), 0) * qty;

            rows.push({ label: detail.item_detail, subtotal, qty });
            grandTotal += subtotal;
          });
        });

        return { rows, grandTotal };
      },
    },
    mounted: function () {
      this.checkLoggedIn();
      this.checkRdLeader();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
    },
    methods: {
      // ── existing methods (unchanged) ──────────────────────────────────────
      checkRdLeader() {
        let self = this;
        if (self.login_user_name === 'albert.chen') {
          self.fields = [
            { key: 'sub_function_name', label: 'Sub Function Name', thClass: 'align-middle', sortable: false },
            { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
            { key: 'rd_check_item_details', label: 'Check Item', thClass: 'align-middle', sortable: false },
            { key: 'special_list', label: 'Special List', thClass: 'align-middle', sortable: false },
            { key: 'schedule_m_d', label: 'Schedule', thClass: 'align-middle', sortable: false },
            { key: 'man_power', label: 'Man Power', thClass: 'align-middle', sortable: false },
            { key: 'relation_dept', label: 'Relation Dept', thClass: 'align-middle', sortable: false },
            { key: 'agree', label: 'RD Leader Agree', thClass: 'align-middle', sortable: false }
          ];
        } else {
          self.fields = [
            { key: 'sub_function_name', label: 'Sub Function Name', thClass: 'align-middle', sortable: false },
            { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
            { key: 'rd_check_item_details', label: 'Check Item', thClass: 'align-middle', sortable: false },
            { key: 'special_list', label: 'Special List', thClass: 'align-middle', sortable: false },
            { key: 'schedule_m_d', label: 'Schedule', thClass: 'align-middle', sortable: false },
            { key: 'man_power', label: 'Man Power', thClass: 'align-middle', sortable: false },
            { key: 'relation_dept', label: 'Relation Dept', thClass: 'align-middle', sortable: false },
            { key: 'action', label: 'Action', thClass: 'align-middle', sortable: false },
          ];
        }
      },
      checkBelongOwner(owner) {
          let self = this;
          let check_disable_result = true;
          /**
  
return self.login_user_name !== owner; */

          if (
            (self.login_user_name === owner) || self.$options.filters['adminAccessFtie'](self.login_user_name, null, null) === true
            || (self.userSites && self.userSites.includes('Getac') && self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
          ) {
            check_disable_result = false;
          } else {
            check_disable_result = true;
          }

          return check_disable_result;

      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/';
        this.$axios.get(url).then(() => {
          this.$router.push("/");
        });
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:", user_name);
        console.log("user_email:", user_email);
        console.log("user_functions:", user_functions);
        console.log("user_roles:", user_roles);
        console.log("user_site:", user_site);

        this.login_user_name = user_name;
        this.userSites = user_site;
        this.userRoles = user_roles;
        this.userFunctions = user_functions;
      },
      getRdCheckItem() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/rd-check-item/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          ftie_id: encodeURI(self.$route.params.ftie_id),
          request_form_id: encodeURI(self.$route.params.request_form_id)
        };

        eventHub.$emit('loading', true);
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;

            if (response.status === 200) {
              self.rd_check_item_data = JSON.parse(res['rd_check_item_data']);
              self.request_form = JSON.parse(res['request_form']);
              self.ref_proposal_files = JSON.parse(res['ref_proposal_files']);
              self.tl_approval = _.find(JSON.parse(res['request_form_approvals']), { approval_function: 'FESC TL' });

              // ── NEW: restore persisted cost data if backend returns it ──
              if (res['cost_data']) {
                try {
                  self.costsByItem = JSON.parse(res['cost_data']);
                } catch (e) {
                  console.warn('Failed to parse cost_data from server:', e);
                }
              }
            } else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            } else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var logoutUrl = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(logoutUrl).then(() => {
                self.$router.push("/");
              });
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      updateCheckItemDetail(rd_check_item) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/rd-check-item/';
        let request_data = { rd_check_item };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                window.location = this.frontEndUrlToUse + 'ftie/rd-check-item/' +
                  encodeURIComponent(self.$route.params.ftie_id) + '/' +
                  encodeURIComponent(self.$route.params.request_form_id);
              }
            } else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var logoutUrl = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(logoutUrl).then(() => { self.$router.push("/"); });
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      uploadfile(event) {
        let self = this;
        let maxLength = Number(self.$root.maxRequestLength);
        if (event) event.preventDefault();
        if (event.target.files.length === 0) return;
        if (_.first(event.target.files).size > maxLength) {
          self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
          return;
        }
        let formData = new FormData();
        formData.append('file', _.first(event.target.files));
        formData.append('ftie_id', self.$route.params.ftie_id);
        formData.append('request_form_id', self.$route.params.request_form_id);
        formData.append('user_name', self.$store.state.username);
        formData.append('user_role', 'RD leader');

        eventHub.$emit('loading', true);
        self.$axios.post(
          self.$root.baseUrl + '/ftie/upload-proposal-file/',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        ).then(() => {
          window.location = this.$root.frontEndUrl + '/ftie/rd-check-item/' +
            encodeURIComponent(self.$route.params.ftie_id) + '/' +
            encodeURIComponent(self.$route.params.request_form_id);
        }).finally(() => {
          eventHub.$emit('loading', false);
        });
      },
      updateRdLeaderComment() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/approve-summary-comment/';
        let request_data = {
          rd_leader_comment: self.rd_leader_comment,
          ftie_id: self.$route.params.ftie_id,
          request_form_id: self.$route.params.request_form_id
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                window.location = this.$root.frontEndUrl + '/ftie/rd-check-item/' +
                  encodeURIComponent(self.$route.params.ftie_id) + '/' +
                  encodeURIComponent(self.$route.params.request_form_id);
              }
            } else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var logoutUrl = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(logoutUrl).then(() => { self.$router.push("/"); });
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      downloadAttachment(file_name, origin_file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/upload_file/' + file_name;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          origin_file_name: origin_file_name
        };
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params, responseType: 'arraybuffer' })
          .then((response) => {
            if (response.status === 200) {
              const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = blobUrl;
              link.setAttribute('download', origin_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(blobUrl);
            } else if (response.status === 401) {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var logoutUrl = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(logoutUrl).then(() => { self.$router.push("/"); });
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      handleInputChange(event) {
        this.fesc_tl_comment = event;
      },
      updateRequestForm(complete_flag) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/update-request-form-approval/';
        let temp_date = null;
        let temp_comment = null;
        if (complete_flag) {
          temp_date = moment().format('YYYY-MM-DD');
        } else {
          temp_comment = self.fesc_tl_comment;
        }
        let request_data = {
          request_form_id: self.request_form.uni_id,
          proposal_complete_date: temp_date,
          update_comments: temp_comment,
          ftie_id: self.request_form.ftie_id,
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                self.$message.info('Save success!');
              } else {
                self.$message.exception('Save fail!');
              }
            } else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var logoutUrl = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(logoutUrl).then(() => { self.$router.push("/"); });
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.fesc_tl_comment = null;
            self.getRdCheckItem();
          });
      },

      // ── NEW: cost feature methods ─────────────────────────────────────────

      /**
       * Toggle the cost collapse panel for a given item_detail.
       * Also initialises the cost entry object on first open (idempotent).
       */
      toggleCostPanel(itemDetail) {
        const isOpen = !!this.showCostPanel[itemDetail];
        this.$set(this.showCostPanel, itemDetail, !isOpen);
        // Lazy-init: only build the entry if it doesn't exist yet
        if (!this.costsByItem[itemDetail]) {
          this.$set(this.costsByItem, itemDetail, makeCostEntry(itemDetail));
        }
      },

      /**
       * Inline subtotal helper used in the table footer (avoids .find() in template).
       */
      getSubtotal(itemDetail) {
        const entry = this.costsByItem[itemDetail];
        if (!entry) return 0;
        const qty = parseInt(entry.deviceQty) || 1;
        const all = [...entry.requiredCosts, ...entry.extraCosts];
        return all.reduce((s, c) => s + safeNum(c.value), 0) * qty;
      },

      /**
       * Append a blank extra cost row for the given item_detail.
       */
      addExtraCostRow(itemDetail) {
        const entry = this.costsByItem[itemDetail];
        if (!entry) return;
        entry.extraCosts.push({ name: '', value: '', note: '' });
      },

      /**
       * Remove an extra cost row by index.
       */
      removeExtraCostRow(itemDetail, index) {
        const entry = this.costsByItem[itemDetail];
        if (!entry) return;
        entry.extraCosts.splice(index, 1);
      },

      /**
       * Persist costsByItem to the backend as a JSON string in the existing
       * rd-check-item endpoint, using a save_cost_only flag so the backend
       * can route it to the cost-data column without touching other fields.
       *
       * Backend requirement: accept { save_cost_only: true, cost_data, ftie_id,
       * request_form_id } and return { save_success: "true" }.
       * Also return cost_data in the GET response to restore on page load.
       */
      saveCostData() {
        let self = this;
        const url = self.$root.baseUrl + '/ftie/rd-check-item/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        const request_data = {
          save_cost_only: true,
          cost_data: JSON.stringify(self.costsByItem),
          ftie_id: self.$route.params.ftie_id,
          request_form_id: self.$route.params.request_form_id,
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                self.$message.info('Cost data saved!');
              } else {
                self.$message.exception('Cost data save failed!');
              }
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/fesc-rd-checkitem-nre/RdCheckItemCost.vue